<section [editableInStoryblok]="_editable()" data-test-id="card-section">
	<div
		[class]="sectionBackgroundClass() | sectionBgClass"
		class="section-spacing"
	>
		<div class="section-inner section-gap">
			<sb-columns [colOne]="titleInput()" component="columnOne" />
			<div [class]="cardGridSize()" class="column-gap !grid">
				@for (blok of cards(); track $index) {
					<ndc-dynamic
						[ndcDynamicComponent]="components[blok['component']]"
						[ndcDynamicInputs]="blok"
						class="hidden"
					/>
				}
			</div>
		</div>
	</div>
</section>
